import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { isDefined } from '@trimble-gcs/common';
import { TranslationService } from '@trimble-gcs/i18n';
import { NG_DEFAULT_LOCALE } from '@trimble-gcs/i18n-types';
import { ConnectService } from '../connect/connect.service';
import { LocaleState } from '../hosts/app-bar/locale-select/locale.state';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  private readonly store = inject(Store);
  private readonly connectService = inject(ConnectService);
  private readonly translationService = inject(TranslationService);

  async initLocale(): Promise<void> {
    let locale: string | undefined;
    const ws = await this.connectService.getWorkspace();

    if (isDefined(ws)) {
      const user = await ws.api.user.getUser();
      locale = user?.language;
    } else {
      locale = this.store.selectSnapshot(LocaleState.locale);
    }

    return await this.translationService.setLocale(locale ?? NG_DEFAULT_LOCALE);
  }
}
